const typographyModalDocCompany = {
  true: 'Registrar Nuevo Documento',
  false: 'Editar Documento'
};

export default typographyModalDocCompany;
